import React from 'react'
import "./possibility.css"
import img from "../../assets/possibility.png"
const Possibility = () => {
  return (
    <div className="gpt3__possibility section__padding" id="possibility">
      <div className="gpt3__possibility-image">
        <img src={img} alt="" />
      </div>
      <div className="gpt3__possibility-content">
        <h4>Request Early Access to Get Started</h4>
        <h1 className='gradient__text'>The possibilities are beyond your imagination</h1>
        <p>They are capable of generating human-like text and have a wide range of applications, including language translation, language modelling, and generating text for applications such as chatbots. GPT-3 is one of the largest and most powerful language processing AI models to date, with 175 billion parameters..</p>
        <h4>Request Early Access to Get Started</h4>
      </div>
    </div>
  )
}

export default Possibility